module.exports = __webpack_public_path__ + "img/service-ico.e54444a0.png";